import React from 'react';
import ErrorStateIcon from '../ErrorStatePage/errorState.inline.svg';
import {SVGIcon} from '../ui/SVGIcon/SVGIcon';
import styles from './ErrorState.scss';

export function ErrorState(props) {
  const {children} = props;
  return (
    <div className={styles.errorState} data-hook="errorState">
      <div className={styles.errorStateIconContainer}>
        <SVGIcon className={styles.errorStateIcon} Svg={ErrorStateIcon} accHidden />
      </div>
      {children}
    </div>
  );
}
